import { defineMessages } from 'react-intl';

const messages = defineMessages({
  PeppolRequired: 'Peppol required',
  RelationPicker: 'Relation picker',
  ChooseRelations: 'Choose relations',
  VatNumberType: 'VAT number type',
  TaskScheduleDeviationOnMainParentPropagationToSubtaskExplanation:
    'TaskScheduleDeviationOnMainParentPropagationToSubtaskExplanation',
  ResetToTemplateSetting: 'Reset to template setting',
  UserFromMainTask: 'User from main task',
  MainTask: 'Main task',
  GeneralSetting: 'General setting',
  Yes: 'Yes',
  SendInvoiceSoftware: 'Send invoice software',
  OtherSoftware: 'Other software',
  WithAssignments: 'With assignments',
  SoftwareType: 'Software type',
  WithTeams: 'With teams',
  WithoutTeams: 'Without teams',
  StartDate: 'Start date',
  StartDateFrom: 'Start date from',
  StartDateUntil: 'Start date until',
  Name: 'Name',
  LastName: 'Last name',
  FirstName: 'First name',
  Infix: 'Infix',
  Initials: 'Initials',
  Alias: 'Commerciele naam',
  Location: 'Location',
  Phone: 'Phone',
  Email: 'Email',
  Active: 'Active',
  Status: 'Status',
  Delete: 'Delete',
  NoRelationsFound: 'No relations found',
  Relations: 'Relations',
  VatPending: 'VAT pending',
  Export: 'Export',
  ExportRelations: 'Export relations',
  ExportAuthorizations: 'Export authorizations',
  ExportLinkedRelations: 'Export linked relations',
  ExportFiscalSections: 'Export fiscal sections',
  ExportCommunicationChannels: 'Export communication channels',
  ExportCommunicationSettings: 'Export communication settings',
  VatOrEnterpriseNumber: 'VAT/Enterprise number',
  Yes: 'Yes',
  No: 'No',
  Template: 'Template',
  DeleteRelation: 'Delete relation',
  NoTemplatesFound: 'No templates found',
  OpenEmailTemplates: 'Open email templates',
  NoEmailTemplateFoundInLanguage: 'No email template was found in {language}',
  ChooseTemplate: 'Choose template',
  Templates: 'Templates',
  PlaceholdersWillBeResolvedByAdminPulse: 'The visible placeholders will be resolved by AdminPulse',
  DeleteRelationConfirmationMsg:
    'Are you sure you want to delete this relation? All tasks and task schedules linked to this relation will be deleted as well.',
  RelationPutInactive:
    'Relation put inactive because registrations and/or invoices exist for this relation, or because this relation is linked to another relation file',
  Type: 'Type',
  Add: 'Add',
  CountRelationsSelected: 'Selected {count} / {total} relations',

  ClearFilter: 'Clear filter',
  SetTaskSchedulingQueued:
    'Task schedules for the selected relations will be added shortly. Click here to view its progress.',
  SetTaskScheduling: 'Set task scheduling',
  GlobalActions: 'Global actions',
  UpdateField: 'Update field',

  NaceCode: 'NACE code',
  SelectAField: 'Select a field',
  SelectAnEmployee: 'Select an employee',
  UpdateFieldQueued:
    'The field for the selected relations will be updated shortly. Click here to view its progress.',
  ExportToExcel: 'Export to excel',
  SearchRelations: 'Search',
  IncludeInactiveRelations: 'Show inactive',
  PaymentMethod: 'Payment method',
  ResetFilters: 'Reset filters',
  LegalForms: 'Legal forms',
  WithLabels: 'With labels',
  WithoutLabels: 'Without labels',
  FilterLinkType: 'Filter on link type',
  FilterLinkTypeReverse: 'Filter on link type (reverse)',
  LinkType: 'Link type',
  LinkTypeReverse: 'Link type (reverse)',
  NewRegistration: 'New registration',
  NewRegistrationsQueued: 'New registrations will be created shortly.',
  SetInvoiceSchedule: 'Set invoice schedule',

  RelationGlobalActionsTooltip:
    'Select one or more relations to execute a global action on these relations.',
  CreateTaskWithoutPlanning: 'Create task without planning',
  CreateTaskQueued:
    'The task will be added shortly to all selected relations. Click here to view its progress.',
  OpenTimeline: 'Open timeline',
  AuditLog: 'Audit log',
  Actions: 'Actions',
  MsgEmailAttachmentUploadFailed: 'An error occurred when uploading the email attachment',
  SendEmail: 'Send email',
  SendEmailQueued:
    'Emails for the selected relations are being sent. Click here to view its progress.',
  EmailContentRequired: 'The email must have content.',
  ClickHereToCreateFreeTextEmail:
    'Choose a template or click here to start typing an email without template.',
  Placeholders: 'Placeholders',
  UseThesePlaceholdersInYourEmail: 'Use these placeholders in your e-mail.',
  AddOrRemoveTeams: 'Add or remove teams',
  AddTeamToRelationQueued:
    'The team will be added to the selected relations shortly. Click here to view its progress.',
  RemoveTeamFromRelationQueued:
    'The team will be removed from the selected relations shortly. Click here to view its progress.',

  Action: 'Action',
  Team: 'Team',
  AddTeam: 'Add team',
  RemoveTeam: 'Remove team',
  SelectATeam: 'Select a team',
  UpdateRelationTeamNotInATeam: 'You are not assigned to a team',
  ClickHereToGoToTeamSettings: 'Click here to go to the teams setting page',
  SelectAValue: 'Select a value',
  Unassigned: 'Unassigned',
  AdvanceFilters: 'Advanced filters',
  HideFilters: 'Hide filters',
  VatPeriodicity: 'VAT periodicity',
  All: 'All',
  EmptyFiscalYear: 'Without fiscal year',
  ChooseDate: 'Choose date',
  EndFiscalYear: 'End fiscal year',
  NotSubjectToVAT: 'Not subject to VAT',
  EmptyVATPeriodicity: 'Empty VAT periodicity',
  AddOrRemoveTags: 'Add or remove tags',
  RemoveTags: 'Remove tags',
  AddTags: 'Add tags',
  Tags: 'Tags',
  EnterTag: 'Enter tag',
  AddTagsToRelationQueued: 'The label(s) will be added to the selected relations shortly.',
  RemoveTagsFromRelationQueued: 'The label(s) will be removed from the selected relations shortly.',
  AddOrRemoveTaskSchedule: 'Add or remove task schedule',
  Deadline: 'Deadline',
  StartPlanning: 'Start planning',
  EndPlanning: 'End planning',
  TaskTemplate: 'Task template',
  Schedule: 'Schedule',
  AddTaskSchedule: 'Add task schedule',
  RemoveTaskSchedule: 'Remove task schedule',
  DeletePlannedTasks: 'Delete planned tasks',
  DeletePlannedTasksTooltip:
    'This will delete all tasks that were created by this schedule from the taskboard and other task screens.',
  DeleteTaskScheduleQueued: 'The task schedules will be deleted shortly.',
  SetInvoiceScheduleQueued:
    'Invoice schedules for the selected relations will be added shortly. Click here to view its progress.',
  VatNumber: 'VAT number',
  NationalNumber: 'National number',
  FilterLanguage: 'Filter on language',
  Language: 'Language',
  FilterCountry: 'Filter on country',
  Country: 'Country',
  Teams: 'Teams',
  OwnCompany: 'Own company',
  SelectYourFilters: 'Select your filters',
  SelectAll: 'Select all',
  Filters: 'Filters',
  MoreFilters: 'More filters',
  ColumnConfig: 'Configure columns',
  SelectOverviewColumns: 'Select overview columns',
  CustomerCode: 'Customer code',
  CustomerCodeSearch: 'Search Customer code',
  AccountingNumber: 'Accounting number',
  FinancialStatementScheme: 'Financial statement scheme',
  UniqueIdentifier: 'Unique Identifier',
  ShareRegister: 'Share register',
  ShareRegisterNotFilledOut: 'Share registration not filled out',
  Jurisdiction: 'Jurisdiction',
  Sector: 'Sector',
  AddAssignment: 'Add assignment',
  BackgroundJobQueued: 'A background job has started. Click here to monitor the progress.',
  UpdateRelationUser: 'Update relation user',
  UpdateUserInPlannedTasks: 'Do you also want to update the assigned user in tasks?',
  RelationUserIsUnassignedWhichUserDoYouWantToAssignToTasks:
    'You set the relation user to unassigned, which user should we use for updating the assigned user in the tasks?',
  GenerateDocuments: 'Generate documents',
  GenerateDocumentsQueued:
    'The documents are being generated for the selected relations. Click here to view its progress.',
  KvkNumber: 'KvK number',
  ObNumber: 'OB number',
  LbNumber: 'LB number',
  RsinNumber: 'RSIN number',
  BsnNumber: 'BSN number',
  FiscalNumber: 'Fiscal number',
  SearchOnPeppolNetwork: 'Search on PEPPOL network',
  EndDate: 'End date',
  AssignedTo: 'Assigned to',
  TaskScheduleDeviation: 'Task schedule deviation',
  ClickToConfigureDeviations: 'ClickToConfigureDeviations',
  Task: 'Task',
  ScheduleDeviation: 'Schedule deviation',
  ExecutionDuration: 'Execution duration',
  ExportToExcelStarted: 'Export to Excel started',
  Pep: 'Pep',
  LinkedToPep: 'LinkedToPep',
  Nationality: 'Nationality',
  TotalRisk: 'AMLEndScore',
  FilterNationality: 'Filter nationality',
  SetSoftware: 'Set software',
  Remove: 'Remove',
  Replace: 'Replace',
  Software: 'Software',
  RelationGroup: 'Relation group',
  UseCompanySetting: 'Use company setting',
  NoRelationGroup: 'No relation group',
  CreateNewRelationGroup: 'Create new relation group',
  ConfirmCreateRelationGroup: "Do you want to create the relation group '{value}'?",
  FilterOnCompanyRequired: 'Please filter on a single own company first.',
  DontUpdate: "Don't update",
  NoTemplateForLanguage: 'No template found for this language',
});

export default messages;
